export function smoothScroll() {
    const smoothScrollTrigger = document.querySelectorAll('a[href^="#"]');
    for (let i = 0; i < smoothScrollTrigger.length; i++){
        smoothScrollTrigger[i].addEventListener('click', (e) => {
            e.preventDefault();
            let href = smoothScrollTrigger[i].getAttribute('href');
            let targetElement = document.getElementById(href.replace('#', ''));
            let headerHeight = document.getElementById('masthead').offsetHeight;
            const rect = targetElement.getBoundingClientRect().top;
            const offset = window.pageYOffset;
            const gap = headerHeight;
            const target = rect + offset - gap;
            window.scrollTo({
                top: target,
                behavior: 'smooth',
            });
        });
    }
}

export function smoothScrollOutside(){
    const anchor = location.hash;
    let headerHeight = document.getElementById('masthead').offsetHeight;
    const offset = window.pageYOffset;
    const gap = headerHeight;
    const target = offset - gap - 50;
    if (anchor === '') {
        ;
    } else {
        window.scrollTo({
            top: target,
            behavior: 'smooth',
        });
    }
}